export const pago_categoria = [
  {
    label: "Id",
    name: "idpago_categoria",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Descripción",
    name: "descripcion",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
];
